import { CloseOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Drawer, Flex } from "antd";
import Input from "antd/es/input/Input";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useChat } from "src/contexts/chat.context";
import { i18n } from "src/utils";
import Chat from "./chat";
import "./drawer.css";
import { ChatOption } from "./enums";
import AiAgentFloatButton from "./float-button";
import History from "./history";
import { contentStyle } from "./styles";
import AiAgentTitleTag from "./title-tag";

interface AiAgentProps {
  userId?: string;
  companyCode?: string;
  isFreeTrial?: boolean;
  isAdmin: boolean;
  userName?: string;
  email?: string;
  companyCnpjCpf?: string;
  companyName?: string;
  managerUserPhone?: string;
}

const ROUTES_WITHOUT_CHAT = ["new-sending-documents"];

export default function AiAgent({
  userId,
  companyCode,
  isFreeTrial,
  isAdmin,
  userName,
  email,
  companyCnpjCpf,
  companyName,
  managerUserPhone,
}: AiAgentProps) {
  const { option, setOption, chatToken, lite } = useChat();
  const [group, setGroup] = useState(null);
  const [loadInitialPrompts, setLoadInitialPrompts] = useState(false);

  const { pathname } = useLocation();
  const currentRoute = pathname.split("/")[1];

  const chatOption = localStorage.getItem("ai_chat_option");
  let parsedChatOption = window.innerHeight > window.innerWidth ? ChatOption.NONE : ChatOption.CHAT;
  if (chatOption) {
    parsedChatOption = parseInt(chatOption);
  }

  async function getSettings() {
    axios
      .get(`/users/ai-agent/settings/${companyCode}`)
      .then(({ data }) => {
        setGroup(data?.group ?? "A");
        setLoadInitialPrompts(data?.hasInteraction);
      })
      .catch((_) => {});
  }

  function closeChat() {
    setOption(ChatOption.NONE);
    localStorage.setItem("show_ai_chat", "0");
  }

  useEffect(() => {
    getSettings();
    setOption(parsedChatOption);
    if (lite) closeChat();
  }, [lite]);

  return !ROUTES_WITHOUT_CHAT.includes(currentRoute) ? (
    <>
      <AiAgentFloatButton />
      <Drawer
        rootClassName="root-drawer-chat"
        className="drawer-chat"
        open={!!option}
        onClose={closeChat}
        title={null}
        closable={false}
        mask={false}
      >
        <div style={{ position: "relative", zIndex: 1, height: "100%" }}>
          <Flex
            vertical
            gap={8}
            justify="center"
            align="center"
            style={{
              position: "relative",
              height: "100%",
            }}
          >
            <Chat
              userId={userId}
              token={chatToken}
              isAdmin={isAdmin}
              companyCode={companyCode}
              group={group}
              loadInitialPrompts={loadInitialPrompts}
              setLoadInitialPrompts={setLoadInitialPrompts}
              isFreeTrial={isFreeTrial}
              userName={userName}
              email={email}
              companyCnpjCpf={companyCnpjCpf}
              companyName={companyName}
              managerUserPhone={managerUserPhone}
              closeChat={closeChat}
              lite={lite}
            />
            <History
              token={chatToken}
              isAdmin={isAdmin}
            />

            {!option && (
              <Flex
                style={contentStyle}
                gap={8}
              >
                <AiAgentTitleTag name="Agente QR" />

                <Input
                  style={{ borderRadius: 16, minWidth: 120 }}
                  onFocusCapture={() => {
                    localStorage.setItem("ai_chat_option", ChatOption.CHAT.toString());
                    setOption(ChatOption.CHAT);
                  }}
                  suffix={<SendOutlined style={{ color: "#884ea6" }} />}
                  placeholder={i18n("aiAgent.input.placeholder")}
                />

                <Button
                  shape="circle"
                  size="small"
                  icon={<CloseOutlined />}
                  onClick={closeChat}
                />
              </Flex>
            )}
          </Flex>
        </div>
        {/* pseudo-elemento via CSS-in-JS */}
        <style>
          {`
          .ant-drawer-content.drawer-chat {      
            position: relative;
            border-top-left-radius: 16px;
            border-bottom-left-radius: 16px;        
            // background-color: rgba(0, 0, 0, 0.08) !important;
          }
          .ant-drawer-content.drawer-chat::before {
            content: "";
            position: absolute;
            inset: 0;
            padding: 2px; /* espessura da borda */
            border-top-left-radius: 16px;
            border-bottom-left-radius: 16px;
            background: linear-gradient(to right, #884ea6, #66c790);
            -webkit-mask: 
              linear-gradient(#fff 0 0) content-box, 
              linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
            pointer-events: none;
          }
        `}
        </style>
      </Drawer>
    </>
  ) : (
    <></>
  );
}
